import React, { useState, useEffect } from 'react';

const TestimonialsSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [progress, setProgress] = useState(0);

  const testimonials = [
    {
      id: 1,
      quote: "If you need reliable traffic solutions, we highly suggest to start a partnership with Mount Media. Their commitment to quality has significantly elevated our online presence and contributed to the success of our products. Amazing staff and great attention to detail!",
      author: "Sander Kuyken",
      company: "Growe partners",
      rotation: 2.555
    },
    {
      id: 2,
      quote: "Working with Sander has been an absolute game-changer for our brand. His creative vision and technical expertise delivered results beyond our expectations. The attention to detail is unmatched.",
      author: "Maria Rodriguez",
      company: "Tech Innovations Inc",
      rotation: -1.2
    },
    {
      id: 3,
      quote: "Exceptional design work that perfectly captured our brand essence. The collaborative process was smooth and the final results exceeded all our expectations. Highly recommended for any serious design project.",
      author: "James Chen",
      company: "Digital Solutions Ltd",
      rotation: 3.1
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          setCurrentTestimonial(current => (current + 1) % testimonials.length);
          return 0;
        }
        return prev + 4; // 200ms tick -> 25 steps to 100% ~ 5s
      });
    }, 200);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
  <div className="bg-mainkleur px-4 sm:px-8 py-12 sm:py-16 rounded-[20px] mx-4 sm:mx-5">
      <div className="max-w-[1310px] mx-auto">
        {/* Header */}
          <div className="flex flex-col gap-8 items-start justify-start mb-16 sm:mb-20 lg:mb-32">
            <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between w-full gap-8">
              <div className="font-anton text-[18vw] sm:text-[140px] lg:text-[200px] text-licht leading-[0.9] tracking-[-4px] sm:tracking-[-6px] lg:tracking-[-8px] w-full lg:w-[761px]">
                <p className="mb-0">TESTI</p>
                <p>MONIALS</p>
              </div>
              
              <div className="font-space font-normal text-[15px] sm:text-[17px] lg:text-[20px] text-licht text-left lg:text-right w-full lg:w-[638px]">
                <p className="leading-[1.35] sm:leading-[1.2] lg:leading-[0.907]">
                  Clients talk about trusting a young partner who brings sharp ideas, transparent collaboration, and work that over-delivers without the bloated agency playbook.
                </p>
              </div>
            </div>
          
          <div className="w-full h-px bg-licht opacity-30"></div>
        </div>

        {/* Testimonials Stack */}
        <div className="relative flex justify-center">
          <div className="relative w-full max-w-[895px] h-[480px] sm:h-[520px] lg:h-[580px]">
            {testimonials.map((testimonial, index) => {
              const isActive = index === currentTestimonial;
              const zIndex = isActive ? 10 : testimonials.length - index;
              const opacity = isActive ? 1 : index === (currentTestimonial + 1) % testimonials.length ? 0.8 : 0.6;
              const yOffset = isActive ? 0 : (index - currentTestimonial) * 20;
              const scale = isActive ? 1 : 0.95 - ((index - currentTestimonial) * 0.02);
              
              return (
                <div
                  key={testimonial.id}
                  className="absolute inset-0 transition-all duration-700 ease-out"
                  style={{
                    transform: `translateY(${yOffset}px) scale(${scale}) rotate(${isActive ? testimonial.rotation : 0}deg)`,
                    zIndex,
                    opacity
                  }}
                >
                  <div className="bg-mainkleur border border-licht/50 rounded-[20px] p-5 sm:p-6 lg:p-8 h-full w-full max-w-[85vw] sm:max-w-[90vw] lg:max-w-[797px] mx-auto">
                    <div className="flex flex-col gap-8 sm:gap-10 lg:gap-16 h-full">
                      <div className="flex flex-col">
                        <div className="bg-gradient-to-r from-verloop-oranje-start via-verloop-oranje-mid to-verloop-oranje-end bg-clip-text text-transparent font-anton-sc text-[56px] sm:text-[68px] md:text-[96px] lg:text-[128px] leading-[0.9] mb-0">
                        ''
                        </div>
                        <div className="font-space font-medium text-[16px] sm:text-[20px] md:text-[24px] lg:text-[28px] text-licht leading-[1.2] sm:leading-[1.05] lg:leading-[0.95] -mt-3 sm:-mt-4 lg:-mt-8">
                          <p className="mb-0">{testimonial.quote}</p>
                          <p className="mt-3 sm:mt-4 text-sm sm:text-base lg:text-lg opacity-80">{testimonial.company}</p>
                        </div>
                      </div>
                      
                      <div className="mt-auto">
                        <div className="font-bricolage font-normal text-[20px] sm:text-[24px] md:text-[28px] lg:text-[32px] text-gray-400 leading-[1.05] sm:leading-[0.95] mb-5 sm:mb-6 lg:mb-8">
                          {testimonial.author}
                        </div>
                        
                        {/* Timeline Progress Bar */}
                        <div className="testimonial-timeline">
                          <div 
                            className="timeline-progress"
                            style={{ 
                              width: isActive ? `${progress}%` : '0%',
                              transition: 'width 0.1s linear'
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Testimonial Indicators */}
        <div className="flex justify-center gap-3 mt-8">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => {
                setCurrentTestimonial(index);
                setProgress(0);
              }}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentTestimonial 
                  ? 'bg-gradient-to-r from-verloop-oranje-start to-verloop-oranje-end' 
                  : 'bg-licht/30 hover:bg-licht/50'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSection;
